import React from 'react';
import './Skills.css';

const Skills = () => {
  return (
    <>
      <section style={{ overflow: 'hidden' }} className='container' id='skills'>
        <div
          data-aos='zoom-in'
          data-aos-duration='2000'
          className='aos-init aos-animate'
        >
          <h1>
            Professional <span>Skillset</span>
          </h1>
        </div>
        <div className='row'>
          <div className='counter'>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/kghM7WP/html.png' alt='' />
                <h6>HTML</h6>
              </div>
            </div>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/fptq0g4/css.png' alt='' />
                <h6>CSS</h6>
              </div>
            </div>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/tHKq06G/bootstrap.png' alt='' />
                <h6>Bootstrap</h6>
              </div>
            </div>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/chg6nyJ/tailwaind.png' alt='' />
                <h6>Tailwind CSS</h6>
              </div>
            </div>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/6yvQzmv/metarial-ui.png' alt='' />
                <h6>Material UI</h6>
              </div>
            </div>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/jvDMNwF/javascript.png' alt='' />
                <h6>JavaScript</h6>
              </div>
            </div>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/Fz7Zps6/react.png' alt='' />
                <h6>React Js</h6>
              </div>
            </div>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/gt5mcXF/firebase.png' alt='' />
                <h6>Firebase</h6>
              </div>
            </div>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/L1hpQDb/github.png' alt='' />
                <h6>GitHub</h6>
              </div>
            </div>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/7Sp7dyH/express.png' alt='' />
                <h6>Express Js</h6>
              </div>
            </div>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/t3fk3vt/node-js.png' alt='' />
                <h6>Node Js</h6>
              </div>
            </div>
            <div
              data-aos='zoom-in-up'
              data-aos-duration='2000'
              data-aos-anchor-placement='center-bottom'
              class='aos-init aos-animate'
            >
              <div className='box'>
                <img src='https://i.ibb.co/KxpMRzD/mongodb.png' alt='' />
                <h6>MongoDB</h6>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Skills;
